export default __webpack_public_path__ + "static/media/top-games-img-three.f2accff4.png";